import { render } from "./SubmitButton.vue?vue&type=template&id=89648584&scoped=true&ts=true"
import script from "./SubmitButton.ts?vue&type=script&lang=ts&external"
export * from "./SubmitButton.ts?vue&type=script&lang=ts&external"

import "./SubmitButton.scss?vue&type=style&index=0&id=89648584&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89648584"]])

export default __exports__